import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  },
  hiddenBorderRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
  tableHead: {
    '& th': {
      backgroundColor: theme.palette.common.white,
      zIndex: 2,
    },
  },
  tableHeadPaper: {
    '& th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& th:last-child': {
      borderTopRightRadius: 4,
    },
  },
  highlightedRow: {
    fontWeight: 'bold',
  },
  lastTableRow: {
    marginRight: theme.spacing(1),
  },
  noWrapContainer: {
    maxWidth: 0,
  },
  noWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))
